import style from './Skeleton.css';

export default function Skeleton({
  className = '',
  css = {},
  width = '100px',
  height = '15px',
  radius = 'px',
}) {
  const skeletonStyle = {
    width,
    height,
    borderRadius: radius,
    ...css,
  };

  return (
    <div
      className={`${className} ${style.skeleton}`}
      style={skeletonStyle}
    ></div>
  );
}
